(() => {
  'use strict';
  if (window.verumaCountdownLoaded) return;
  window.verumaCountdownLoaded = true;
  const timers = [];
  const deadlines = new Map();
  document.querySelectorAll('gp-countdown-timer').forEach(timer => {
    if (!timer.querySelector('[id="section-countdown"]')) return;
    let config;
    try { config = JSON.parse(timer.getAttribute('gp-data')); } catch (_) { return; }
    if (config.behaviour !== 'evergreen') return;
    const duration = config.timerEverygreen || {};
    const seconds = (Number(duration.days) || 0) * 86400 +
      (Number(duration.hours) || 0) * 3600 +
      (Number(duration.mins) || 0) * 60 + (Number(duration.seconds) || 0);
    if (seconds <= 0) return;
    const key = 'veruma-ceylon-countdown-v1-' + seconds;
    let deadline = deadlines.get(key);
    if (!deadline) {
      try { deadline = Number(sessionStorage.getItem(key)); } catch (_) { /* Storage may be disabled. */ }
      if (!Number.isFinite(deadline) || deadline <= 0 || deadline > Date.now() + seconds * 1000) {
        deadline = Date.now() + seconds * 1000;
        try { sessionStorage.setItem(key, String(deadline)); } catch (_) { /* Keep an in-memory deadline. */ }
      }
      deadlines.set(key, deadline);
    }
    const fields = Array.from(timer.querySelectorAll('.gp-countdown-number'));
    const units = [['enableWeek', 604800], ['enableDay', 86400], ['enableHour', 3600], ['enableMinute', 60], ['enableSecond', 1]]
      .filter(([enabled]) => config[enabled]);
    if (fields.length !== units.length) return;
    timers.push({ timer, fields, units, deadline });
  });
  function update() {
    timers.forEach(({ timer, fields, units, deadline }) => {
      let remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      if (!remaining) {
        const row = timer.closest('gp-row') || timer;
        row.hidden = true;
        row.style.display = 'none';
        return;
      }
      units.forEach(([, size], index) => {
        const value = Math.floor(remaining / size);
        remaining %= size;
        fields[index].textContent = String(value).padStart(2, '0');
      });
    });
  }
  update();
  if (timers.length) window.setInterval(update, 1000);
})();
